import styled from '@emotion/styled'
import { calcRem, fonts, metrics } from '../../../__styling'
import { tokens } from '@news-mono/design-tokens'

export const StyledWardenParagraph = styled('p')({
    fontFamily: fonts.thenightly.sansSerif,
    fontSize: calcRem(metrics.thenightly.baseFontSize),
    fontWeight: 400,
    lineHeight: calcRem(24),
    color: tokens.thenightly.colors.text.tertiary,

    // Handle formatting on all clickable links below:
    a: {
        textDecorationLine: 'underline',
    },
})
StyledWardenParagraph.displayName = 'StyledWardenParagraph'
